import React, {FC, useState, useEffect} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {person} from '../../../schema/person'
import {PersonModel} from '../../../model'
import {useCentral} from '../../../../../hooks/useCentral'
import ActionsContent from '../../componentes/Actions'
import {TabCentralModel} from '../../../../../models'
import {createPerson, deletePerson, updatePerson} from '../../../services'
import {renderPanelContent} from '../components'
import {funcDelete} from '../../../util/function'
import {ShowSnackBar, getDataModified} from '../../../../../util/functions'
import PanelWrapper from '../../../../../components/UI/Panel'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
  ERROR_MESSAGE_SYSTEM,
} from '../../../../../util/Constants'
import {initValues} from '../../../util/values/person'
import {getTypeDocument} from '../../../util/functions'
const PersonPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()

  const [loading, setLoading] = useState(false)
  const [documentTypes, setDocumentTypes] = useState<any[]>([])
  const methods = useForm<PersonModel>({
    defaultValues: initValues,
    resolver: yupResolver(person(documentTypes)),
  })
  const {reset} = methods
  const getDocument = async () => {
    const result = await getTypeDocument()
    setDocumentTypes(result)
  }
  useEffect(() => {
    getDocument()
  }, [])

  const handleDelete = async () => {
    await funcDelete(
      deletePerson,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: PersonModel) => {
    try {
      setLoading(true)
      data = getDataModified(data)
      const isCreating = !currentTabItem.idToEdit

      const response = isCreating
        ? await createPerson(data)
        : await updatePerson({...data, id: currentTabItem.idToEdit})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: isCreating ? true : false,
          currentExternalTab: isCreating ? 1 : undefined,
          fromCreateButton: isCreating ? true : false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-person',
            detailPanel: isCreating ? 'tab-document' : undefined,
          },
          idToEdit: response.data.Id,
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error('Error en la operación:', error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-person'
          textComponentGo='form-person'
        />
        <PanelWrapper currentTab={currentTabItem} renderPanelContent={renderPanelContent} />
      </form>
    </FormProvider>
  )
}

export default PersonPageWrapper
